export default "__VITE_ASSET__Cyol6Dm7__"